import { baseUrl } from "../Constants";
export const paymentProviderTableHeaders = [
  { id: "id", numeric: true, disablePadding: false, label: "ID" },
  { id: "name", numeric: false, disablePadding: true, label: "Provider Name" },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Date Created",
  },
  {
    id: "updatedAt",
    numeric: false,
    disablePadding: true,
    label: "Date Updated",
  },
];

export const paymentProviderTableSchema = {
  id: { value: "", type: "number", label: "ID", readOnly: true },
  name: { value: "", type: "text", label: "Provider Name" },
  createdAt: {
    value: "",
    type: "text",
    label: "Date Created",
    readOnly: true,
  },
  updatedAt: {
    value: "",
    type: "text",
    label: "Date Updated",
    readOnly: true,
  },
};
export const createPaymentProviderRecord = (data) => {
  let record = {
    id: { value: data.id, type: "number", label: "ID", readOnly: true },
    name: { value: data.name, type: "text", label: "Provider Name" },
    createdAt: {
      value: data.createdAt,
      type: "text",
      label: "Date Created",
      readOnly: true,
    },
    updatedAt: {
      value: data.updatedAt,
      type: "text",
      label: "Date Updated",
      readOnly: true,
    },
  };
  return record;
};

export const paymentProviderTableIdField = "id";
export const paymentProviderTableTitle = "Payment Providers";
export const paymentProviderBaseUrl = baseUrl + "payment-providers";
